export enum alchemyType{
    //材料
    material,
    //丹药
    elixir,
    //燃料
    fuel
}

//物品接口
export interface alchemyNormalObj{
    //物品id
    id:number,
    //物品类型
    type:alchemyType,
    //是否可以放入
    pushFlag?:boolean,
    //物品名字
    name:string,
    //物品图片路径
    spPath:string,
    //购买价格
    buyCoin:number,
    //出售价格
    sellCoin:number
}

//合成接口
export interface synthesisInterface{
    //合成物品的所需id集合
    ids:number[];
    //合成出来的物品id
    synthesisId:number
}

//物品表
export interface alchemyMap{
    [id:number] : alchemyNormalObj;
}
//合成表
export interface synthesisMap{
    [id:number]:synthesisInterface
}

//合成概率接口
export interface synthesisProInteface{
    //合成的物品id
    alchemyId:number,
    //合成的概率
    pro:number
}

export let synthesisPro:synthesisProInteface[] = [
    //灰烬概率
    {alchemyId:0,pro:60},
    //真元丹概率
    {alchemyId:0,pro:5},
    //聚灵丹概率
    {alchemyId:0,pro:5},
    //合气丹概率
    {alchemyId:0,pro:5},
    //金髓丹概率
    {alchemyId:0,pro:5},
    //血气丹概率
    {alchemyId:0,pro:5},
    //紫英丹概率
    {alchemyId:0,pro:5},
    //碧焰丹概率
    {alchemyId:0,pro:5},
    //虚灵丹概率
    {alchemyId:0,pro:4},
    //清虚丹概率
    {alchemyId:0,pro:1},
]
